/**
 * A colour, in the three forms the interface needs it.
 *
 * The format stores every colour as RGBA numbers, CSS wants a string, and the
 * browser's own colour picker only speaks six-digit hex and cannot carry alpha.
 * These three sit here rather than in the workbench because the part editor
 * needs them too, and a second copy would be a second place for the alpha
 * rounding to drift.
 */

import type { Rgba } from "../src/raster.js";

/** For anything painted with CSS. Keeps alpha, which hex cannot. */
export const css = (c: readonly number[]) => `rgb(${c[0]} ${c[1]} ${c[2]} / ${c[3] / 255})`;

/** For `<input type="color">`, which is opaque by definition. */
export const hex = (c: readonly number[]) =>
	`#${[c[0], c[1], c[2]].map((n) => n.toString(16).padStart(2, "0")).join("")}`;

/** Back from the picker, with the alpha the role already had carried over. */
export const fromHex = (h: string, alpha: number): Rgba => [
	parseInt(h.slice(1, 3), 16),
	parseInt(h.slice(3, 5), 16),
	parseInt(h.slice(5, 7), 16),
	alpha,
];
